exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PrivacyScreen .Modal__Content {\n  height: 100%; }\n\n.PrivacyScreen .Section {\n  height: 100%; }\n\n.PrivacyScreen .Container {\n  height: 100%; }\n\n.PrivacyScreen .Wrap {\n  background: #fff;\n  height: 100%;\n  border-radius: 4px;\n  padding: 0; }\n\n.PrivacyScreen__Iframe {\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  overflow: hidden; }\n\n.PrivacyScreen iframe {\n  width: 100%;\n  height: 100%; }\n", ""]);

// exports
